/**
 * Map tương ứng AuditingLogAction ở backend
 * nhhoang1 10.05.2023
 */
export default {
  /**
   * Thêm
   */
  Insert: 1,

  /**
   * Sửa
   */
  Update: 2,

  /**
   * Xóa
   */
  Delete: 3,
};
